import React, { useContext } from 'react';
import { FlexMiddle } from '../../Flex';
import ConfigContext from '../../../contexts/ConfigContext';

const OptionsChip = ({ value, options = [] }) => {
  const { t } = useContext(ConfigContext);
  const selected = value ? (Array.isArray(value) ? value : [value]) : [];

  return (
    <FlexMiddle>
      {options
        .filter(({ id }) => selected.includes(id))
        .map(({ title }) => t(title))
        .join(', ')}
    </FlexMiddle>
  );
};

export default OptionsChip;
